$(document).ready(function() {

    // login/register
    $('.switch-signup-modal-forms').on('click', function() {
        var modal = $('#signup-modal');

        modal.find('form').toggle();
        var modal_title = modal.find('form:visible').attr('data-modal-title');
        modal.find('.modal-title').text(modal_title);
    });

    $('#signup-modal .confirm').on('click', function() {
        var form = $('#signup-modal form:visible');
        var action = form.attr('action');
        var formData = form.serialize();

        ajax_post(action, formData, function(response) {
            if (response.status === 'success') {
                form.find('input').val('');
                message(response.status, response.message);
            } else {
                message(response.status, response.message);
            }
        });
    });

    // select2
    $('[data-s2]').select2({
        theme: 'bootstrap'
    });

    // profile
    $('.profile-page form input[type="button"]').on('click', function() {
        var form = $(this).closest('form');
        var action = form.attr('action');
        var formData = form.serialize();

        ajax_post(action, formData, function(response) {
            message(response.status, response.message);
        });
    });

    // mini cart & cart
    $('.js-add-cart-product').submit(function(e) {
        e.preventDefault();
        var args = $(this).serialize();

        ajax_post('/shop/add-to-cart', args, function(response) {
            if (response.status === 'success') {
                $('.js-elem-mini-cart').replaceWith(response.cart);
                updateAddonsInfo(response.currentAddonsWeight, response.isAddonsValid, response.hasAvailableProducts);
            }
            message(response.status, response.message);
        });
    });

    $('.js-remove-cart-product').on('click', function(e){
        removeCartProduct(this, e);
    });

    $('.js-update-cart-item-quantity').on('change', function () {
        var quantity = $(this).val();
        var route = $(this).data('route');
        var args = {
            quantity: quantity
        };
        ajax_post(route, args, function(response){
            if (response.status === 'success') {
                $('.total-price').text(response.total_price);
            }

            message(response.status, response.message);
        });
    });

    $(document).on({
        mouseenter: function () {
            $('.js-elem-mini-cart-bag').addClass('hover');
            openMiniCart($('.js-elem-mini-cart-bag'), true);
        },
        mouseleave: function () {
            $('.js-elem-mini-cart-bag').removeClass('hover');
            setTimeout(function(){
                closeMiniCart($('.js-elem-mini-cart-bag'), true);
            },500);
        }
    }, '.js-show-mini-cart-bag');

    $('.js-elem-mini-cart').parent().on('click', '.js-remove-mini-cart-product', function(e){
        removeCartProduct(this, e);
    });

    // order details modal
    $('#order-details').on('show.bs.modal', function (e) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        var order_id = $(e.relatedTarget).attr('data-order-id')

        $.post('/get-order-details', { order_id: order_id }, function(response) {
            $('#order-details .modal-body').html(response);
        });
    });

    // products search
    $('.search-trigger').on('keyup', function() {
        var search_text = $('.search-trigger').val();

        setTimeout(function() {
            $('.search-content ul.categories').html('');
            $('.search-content ul.products').html('');

            $.post('/shop/search', {search_text: search_text}, function (response) {
                $('.search-content ul.categories').html(response.categories);
                $('.search-content ul.products').html(response.products);
            });
        }, 500);
    });
});

function closeMiniCart(minicart, openAferClose) {
    if(!minicart.hasClass('sliding') && !minicart.hasClass('hover')) {
        minicart.addClass('sliding');
        minicart.stop().slideUp(400, function (e) {
            $(this).removeClass('sliding');
            if(openAferClose && minicart.hasClass('hover')){
                openMiniCart(minicart, false);
            }
        });
    }
}

function openMiniCart(minicart, closeAfterOpen) {
    if(!minicart.hasClass('sliding')) {
        minicart.addClass('sliding');
        minicart.stop().slideDown(400, function () {
            minicart.removeClass('sliding');
            if(closeAfterOpen && !minicart.hasClass('hover')){
                closeMiniCart(minicart, false);
            }
        });
    }
}

function removeCartProduct(element, event) {
    event.preventDefault();
    var args = {
        id: $(element).data('id')
    };
    ajax_post('/shop/remove-from-cart', args, function(response){
        if (response.status === 'success') {
            $('.js-elem-mini-cart').replaceWith(response.cart);
            $('.cart-product-'+args.id).remove();
        }

        message(response.status, response.message);
    });
}


$('.js-add-wishlist-product').submit(function (e) {
    e.preventDefault();
    var args = $(this).serialize();
    var form = $(this);
    ajax_post(window.url.post_addToWishlist, args, function (response) {
        if(response.status =="success"){
            if(response.action == 'added'){
                form.find('.add-wish').addClass('added');
            }else if(response.action == 'removed'){
                form.find('.add-wish').removeClass('added');
                if(form.closest('.wishlist-block').length > 0){
                    form.closest('.product-col').remove();
                }
            }
        }
        message(response.status, response.message);

    });
});

$('.sort-select').change(function(){
    var name = $(this).prop('name');
    var value = $(this).val();
    var route = $(this).data('route');
    var args = {};
    args[name] = value;
    $(".js-archive-prods").addClass("is-loading");
    $.post(route, args, function(data){
        if(data.status === 'success'){
            window.location.reload(true);
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/common/js/demo.js